import { Navigate, Outlet } from "react-router-dom";
import { useAuthContext } from '../hooks/useAuthContext';
import WelcomeMessage from '../pages/WelcomeMessage';

export function ProtectedRoute() {
  const { user, isLoading } = useAuthContext();

  if (isLoading) {
    return <div className="loader">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (user.status === 'pending' || (user.permissions && user.permissions.length === 0)) {
    return <WelcomeMessage />;
  }

  return <Outlet />;
}
